
import { handler, HandlerBody, parseJson } from '.';
import * as model from '../model';

async function voicemailHandlerRaw(body: HandlerBody, ucStatus = true) {
  return await handler('/Handlers/Dialogs/VoicemailProfile.ashx', body, ucStatus)
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
async function voicemailHandler<T>(body: HandlerBody, ucStatus = true) {
  return parseJson<T>(await voicemailHandlerRaw(body, ucStatus))
}

export type RecordingType = 'collaboration' | 'contact-group' | 'contact-personal' | 'personal-group'
export type RecordingAction = 'record' | 'delete'

export async function sendRecordGreetingCommand(type: RecordingType, action: RecordingAction, id: string, myId: model.Identifier) {
  await voicemailHandlerRaw({
    command: action,
    data: type,
    data1: myId.id,
    servername: myId.server,
    id: id,
    extensionId: myId.id,
  })
}
